<footer class="np-footer">
    <ul>
      <li>&copy; {{copyright }} Chevron Corporation</li>
      <li>{{ confidentiality }} </li>
      <li>OpCo: <a href="{{ opCoUrl }}">{{ opCoName }}</a></li>
    </ul>
    <ul>
      <li>Content contact: <a href="{{ contentContactUrl }}"> {{ contentContactName}} </a></li>
      <li>Technical contact: <a href=" {{ technicalContactUrl }}"> {{ technicalContactName }} </a></li>
    </ul>
  </footer>